<div class="grid-row pointer" (click)="groupClick()"> 
    <div class="list-item flex-2 ellipsis ">
        <que-distribution-group-square class="logo-group" [color]="distributionGroup?.color"
            [name]="distributionGroup?.name"></que-distribution-group-square>
        <p class="ellipsis xxx"> {{distributionGroup?.name}}</p>
        <div class="tooltip-abs" *ngIf="distributionGroup?.name">
            <p>{{distributionGroup?.name}}</p>
        </div>
    </div>
    <div class="list-item flex-1">{{distributionGroup?.createDate |queDate }}</div>
    <div class="list-item flex-1 min-width-190">
        <div class="circle">
            <p> {{ distributionGroup?.creator?.firstName ?
                distributionGroup?.creator?.firstName?.charAt(0)?.toUpperCase() : '' }}</p>
            <p>{{ distributionGroup?.creator?.lastName ? distributionGroup?.creator?.lastName?.charAt(0)?.toUpperCase()
                : '' }}</p>
        </div>
        {{distributionGroup?.creator?.firstName}} {{distributionGroup?.creator?.lastName}}
    </div>
    <div class="list-item flex-1">
        <div *ngIf="distributionGroup?.questionnaireAnsweredCount!=0">
            <span>{{distributionGroup?.questionnaireAnsweredCount}} </span>
        </div>
    </div>
    <div class="list-item flex-1">
        <div *ngIf="distributionGroup?.remindersAnsweredCount!=0">
            <span>{{distributionGroup?.remindersAnsweredCount}} </span>
        </div>
    </div>
    <div class="list-item flex-2">
        <que-distribution-recipients [recipients]="userRecipients" [title]="'groups'"></que-distribution-recipients>
        <!-- <que-recipients-reply [users]="distributionGroup?.users"></que-recipients-reply> -->
    </div>
    <div class="list-item flex-half last">
        <que-distribution-group-menu-item (editEvent)="editGroup()"
            [distributionGroup]="distributionGroup"></que-distribution-group-menu-item>
    </div>
</div>